import { subYears } from "date-fns";
import * as types from "../constants/ActionTypes";

let storageFilterStatus = localStorage.getItem("agentDashboardFilter")
  ? JSON.parse(localStorage.getItem("agentDashboardFilter"))
  : "";

let initialState = {
  periodSelectedAgentScreen: [{ id: 5, label: "Personalizar" }],
  profileSelectedAgenteScreen: [{ id: "PROMOTOR", label: "Promotor" }],
  channelSelectedAgentScreen: [],
  groupSelectedAgentScreen: [],
  avaliationSelectedAgentScreen: [],
  initialDateAgenteScreen: new Date(
    new Date().setDate(new Date().getDate() - 30)
  ),
  finalDateAgentScreen: new Date(),
  initialDateYear: subYears(new Date(), 1),
  finalDateYear: new Date(),
};

const hasStorageData = !!storageFilterStatus;
if (hasStorageData) {
  initialState = {
    periodSelectedAgentScreen: storageFilterStatus.periodSelectedAgentScreen,
    profileSelectedAgenteScreen:
      storageFilterStatus.profileSelectedAgenteScreen,
    channelSelectedAgentScreen: storageFilterStatus.channelSelectedAgentScreen,
    groupSelectedAgentScreen: storageFilterStatus.groupSelectedAgentScreen ? storageFilterStatus.groupSelectedAgentScreen:initialState.groupSelectedAgentScreen,
    avaliationSelectedAgentScreen:
      storageFilterStatus.avaliationSelectedAgentScreen,
    initialDateAgenteScreen: storageFilterStatus.initialDateAgenteScreen,
    finalDateAgentScreen: storageFilterStatus.finalDateAgentScreen,
    initialDateYear: storageFilterStatus.initialDateYear
      ? storageFilterStatus.initialDateYear
      : subYears(new Date(), 1),
    finalDateYear: storageFilterStatus.finalDateYear
      ? storageFilterStatus.finalDateYear
      : new Date(),
  };
}

function agentDashboardFilter(state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_FILTERS_AGENT_DASHBOARD:
      let newState = { ...state };
      newState[action.to] = action.value;
      return newState;
    default:
      return state;
  }
}

export default agentDashboardFilter;
